export const inboxPreviewHtml = `
<style>
  /* Gmail Inbox Preview */
  #inbox-preview {
    height: 40px;
    display: flex;
    background-color: white;
    font-size: 14px;
    align-items: center;
    padding: 0 13px;
    font-family: arial, sans-serif;
    border-bottom: 1px solid #e5e5e5;
    overflow: hidden;
  }
  #inbox-preview--profile-photo {
    display: none;
  }
  #inbox-preview--icons {
    font-size: 15px;
    color: #d4d4d4;
    -webkit-font-smoothing: subpixel-antialiased;
    letter-spacing: 2px;
    padding-right: 10px;
    line-height: 9px;
    flex-grow: 0;
    flex-shrink: 0;
    font-family: arial, sans-serif;
  }
  #inbox-preview--current-user {
    font-weight: bold;
    flex-grow: 0;
    flex-shrink: 0;
    font-family: arial, sans-serif;
    min-width: 145px;
    /*		width: 175px;*/
  }
  #inbox-preview--title {
    font-weight: bold;
    flex-grow: 0;
    flex-shrink: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    font-family: arial, sans-serif;
  }
  #inbox-preview--preview-text {
    flex-grow: 1;
    flex-shrink: 10;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #777777;
    font-family: arial, sans-serif;
  }
  #inbox-preview--preview-text:before {
    content: '- ';
  }
  @media all and (max-width: 480px) {
    #inbox-preview {
      display: block;
      padding: 16px 30px 18px 72px;
      height: auto;
      position: relative;
      overflow: auto;
    }
    #inbox-preview--profile-photo {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      position: absolute;
      left: 16px;
      margin-top: 2px;
      display: block;
    }
    #inbox-preview--icons {
      display: none;
    }
    #inbox-preview--current-user {
      font-size: 15px;
      padding-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    #inbox-preview--title {
      font-size: 13px;
      padding-bottom: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    #inbox-preview--preview-text {
      font-size: 13px;
    }
    #inbox-preview--preview-text:before {
      content: '' !important;
    }
  }
</style>
<div id="inbox-preview">
  <svg xmlns="http://www.w3.org/2000/svg" id="inbox-preview--profile-photo" width="40" height="40" fill="none"><g clip-path="url(#a)"><path fill="#EEE" d="M0 0h40v40H0V0Z"/><path fill="#BDBDBD" d="M20 21.667A6.665 6.665 0 0 0 26.667 15 6.665 6.665 0 0 0 20 8.333 6.665 6.665 0 0 0 13.333 15 6.665 6.665 0 0 0 20 21.667Zm0 1.666c-4.45 0-13.333 2.234-13.333 6.667v10h26.666V30c0-4.433-8.883-6.667-13.333-6.667Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z"/></clipPath></defs></svg>
  <div id="inbox-preview--icons">▢ ☆</div>
  <div id="inbox-preview--current-user">{{ username }}</div>
  <div id="inbox-preview--title">{{ subjectLine }}</div>
  <div id="inbox-preview--preview-text">{{ previewText }}</div>
</div>`;
